(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("preregistration", function () {
        return {
            restrict: "E",
            scope: {},
            templateUrl: "app/public/preregistrationView.html",
            controllerAs: "vm",
            bindToController: true,
            controller: ["publicResource", "calendarSettingsService", "messageService", "frameworkService", "$scope", PreregistrationCtrl]
        };
        function PreregistrationCtrl(publicResource, calendarSettingsService, messageService, frameworkService, $scope) {
            var vm = this;
            vm.preregistrationEnabled = frameworkService.data.tenant.tenantFeaturesPreregistrationEnabled;
            if (!vm.preregistrationEnabled)
                return;
            vm.enabledLocalizations = frameworkService.data.tenant.enabledLocalizations;
            vm.selectedLanguage = frameworkService.data.selectedLanguage;
            vm.loading = true;
            vm.saving = false;
            vm.showErrors = false;
            vm.isSpecialCharacter = false;
            vm.isExternalUser = false;
            //Date picker config
            vm.format = "yyyy-MM-dd";
            calendarSettingsService.calendarSetup($scope);
            vm.open = calendarSettingsService.open;
            //Future Date Validation
            vm.checkDate = calendarSettingsService.checkDate;
            publicResource.getPreregistrationViewModel(function (result) {
                vm.model = result;
                vm.loading = false;
            });
            vm.save = function () {
                if (vm.saving)
                    return;
                if (vm.form.$valid) {
                    vm.saving = true;
                    publicResource.savePreregistration(vm.model, function (result) {
                        vm.result = result;
                        vm.saving = false;
                    }, function (error) {
                        messageService.error(error);
                        vm.saving = false;
                    });
                }
                else {
                    vm.showErrors = true;
                }
            };
        }
    });
}());
